import http from "../http";

export async function getUsers(epId) {
  const response = await http.get(`/user-list?epId=${epId}`);
  return response.data;
}

export async function getPartners() {
  const response = await http.get("/enterprise-partners-list");
  return response.data;
}

export async function getUserRoles() {
  const response = await http.get("/user-roles");
  return response.data;
}

export async function inviteUser(data) {
  const response = await http.post("/user/invite", data);
  return response.data;
}

export async function updateInviteUser(data) {
  const response = await http.put("/user/invite", data);
  return response.data;
}

export async function deleteInviteUser(data) {
  const response = await http.delete("/user/invite", { data });
  return response.data;
}

export async function resendInviteUser(data) {
  const response = await http.post("/user/invite/resend", data);
  return response.data;
}

export async function verifyOtp(data) {
  const response = await http.post("/user/invite/otp-verification", data);
  return response.data;
}

export async function createUser(data) {
  const response = await http.post("/user/invite/verify-and-create-ep-user-account", data);
  return response.data;
}
